// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopCriticalPathDelayedActivities(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/critical_activities`);
}
